/* ==========================================================================
   CAIXA FILOSOFAL - Carrossel dos depoimentos

   Empurra um cartao por vez, para a direita, com pausa entre um e outro.

   ---------------------------------------------------------------------------
   O QUE ELE NAO FAZ

   Nao move nada por transform, nao clona cartao e nao mantem indice proprio.
   Quem move e a ROLAGEM NATIVA do container, com `scroll-snap`. Isso importa:

     · sem JavaScript, o carrossel continua sendo uma lista rolavel de
       verdade -- dedo, trackpad, roda do mouse, Tab e leitor de tela;
     · a pessoa pode arrastar no meio do ciclo sem brigar com o script;
     · nao existe estado paralelo para dessincronizar da tela.

   O script so decide QUANDO empurrar.

   ---------------------------------------------------------------------------
   QUANDO ELE PARA

   Movimento automatico que dura mais de cinco segundos precisa de um jeito de
   parar (WCAG 2.2.2), e "tirar o mouse de cima" nao e um jeito: quem navega
   por teclado ou no celular nao tem hover. Por isso ha botao de verdade.

   Alem dele, para sozinho quando:
     · a aba sai de foco -- animar o que ninguem ve gasta bateria;
     · a secao sai da tela;
     · alguem passa o mouse, foca um cartao com o teclado, toca ou arrasta;
     · o sistema pede menos movimento (prefers-reduced-motion).
   ========================================================================== */

(function () {
  'use strict';

  function iniciar() {
    var trilhos = document.querySelectorAll('[data-cf-carrossel]');
    Array.prototype.forEach.call(trilhos, montar);
  }

  function montar(trilho) {
    /* Trava de montagem dupla (11/09). Desde que a seção de projetos passou a
       ser carrossel, este arquivo é pedido por DUAS seções da mesma página.
       Sem a trava, cada trilho ganharia dois intervalos e o carrossel andaria
       dois cartões por vez, do nada. */
    if (trilho.getAttribute('data-cf-montado')) return;
    trilho.setAttribute('data-cf-montado', '1');

    var cartoes = trilho.children;
    if (cartoes.length < 2) return;

    /* O controle e procurado a partir do PROPRIO trilho, e nao no documento
       inteiro. A secao de depoimentos entra na home e nas sete paginas de
       produto; bastava alguem pôr duas na mesma pagina para o segundo
       carrossel comandar os botoes do primeiro. Era bug latente, e a linha
       que o consertava era esta. */
    var raiz = trilho.parentNode || document;
    var ctrl = raiz.querySelector('[data-cf-carrossel-ctrl]') ||
               document.querySelector('[data-cf-carrossel-ctrl]');
    var botao = ctrl ? ctrl.querySelector('[data-cf-carrossel-pausa]') : null;
    var rotulo = ctrl ? ctrl.querySelector('[data-cf-carrossel-rotulo]') : null;
    var seta_volta = ctrl ? ctrl.querySelector('[data-cf-carrossel-volta]') : null;
    var seta_avanca = ctrl ? ctrl.querySelector('[data-cf-carrossel-avanca]') : null;

    var segundos = parseFloat(trilho.getAttribute('data-cf-intervalo')) || 5;
    var espera = Math.max(3, segundos) * 1000;

    var pedidoDoUsuario = false;   // clicou em pausar
    var tocando = false;           // mouse ou foco parados em cima
    var naTela = false;
    var relogio = null;

    /* Descanso depois de qualquer gesto.
       Sem isto, o dedo largava o carrossel e um avanco animado podia comecar
       no meio da inercia da rolagem da pagina -- duas animacoes disputando o
       mesmo container, que e o \"balancando\" que o Elber viu. Tres segundos
       de silencio depois do ultimo gesto, seja no carrossel ou na pagina. */
    var DESCANSO = 3000;
    var ultimoGesto = 0;

    function gestoAgora() { ultimoGesto = Date.now(); }

    function querMenosMovimento() {
      try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {
        return false;
      }
    }

    /* O passo e a largura de UM cartao mais o vao. Medir em vez de guardar:
       o cartao muda de largura entre celular e desktop, e entre um resize e
       outro. */
    function passo() {
      var a = cartoes[0].getBoundingClientRect();
      var b = cartoes.length > 1 ? cartoes[1].getBoundingClientRect() : null;
      return b ? Math.round(b.left - a.left) : Math.round(a.width);
    }

    function noFim() {
      /* 2px de folga: a rolagem raramente para no pixel exato. */
      return trilho.scrollLeft + trilho.clientWidth >= trilho.scrollWidth - 2;
    }

    function noComeco() {
      return trilho.scrollLeft <= 2;
    }

    /* ---------- rolar sem depender do `smooth` (11/09) ----------

       Medido duas vezes, em duas secoes diferentes, na mesma chamada e no
       mesmo elemento: `scrollBy({behavior:'auto'})` anda 192px e
       `scrollBy({behavior:'smooth'})` anda 3. Nao e pagina travada nem
       renderer morto: e a rolagem suave nao acontecendo.

       Enquanto TUDO neste arquivo passava por `smooth`, isso significava um
       carrossel que simplesmente nao anda, nem sozinho nem pelas setas, sem
       erro nenhum no console. Num navegador assim o componente inteiro morre
       em silencio.

       A rede e boba de proposito: pede suave, e um instante depois confere se
       saiu do lugar. Se saiu, nao faz nada e a animacao segue. Se nao saiu,
       escreve o valor direto. Onde o suave funciona, esta funcao e invisivel.

       450ms porque uma rolagem suave de um cartao leva bem menos que isso
       para SAIR do ponto de partida, que e tudo o que a conferencia olha. */
    function rolarPara(alvo) {
      var antes = trilho.scrollLeft;
      if (Math.abs(alvo - antes) < 4) return;

      try {
        trilho.scrollTo({ left: alvo, behavior: 'smooth' });
      } catch (e) {
        trilho.scrollLeft = alvo;
        return;
      }

      window.setTimeout(function () {
        if (Math.abs(trilho.scrollLeft - antes) < 4) trilho.scrollLeft = alvo;
      }, 450);
    }

    function avanca() {
      rolarPara(noFim() ? 0 : trilho.scrollLeft + passo());
    }

    /* Espelho de avanca(). Da a volta na primeira posicao pelo mesmo motivo
       que o avanco da a volta na ultima: a lista e circular, e uma seta que
       nao faz nada no primeiro clique e pior que uma que leva ao fim. */
    function volta() {
      rolarPara(noComeco() ? trilho.scrollWidth : trilho.scrollLeft - passo());
    }

    function podeAndar() {
      return naTela && !pedidoDoUsuario && !tocando &&
             !document.hidden && !querMenosMovimento() &&
             Date.now() - ultimoGesto > DESCANSO;
    }

    /* O relógio nunca para; quem decide e o TIQUE.

       A primeira versão limpava o intervalo a cada gesto e só o recriava se
       `podeAndar()` fosse verdade NAQUELE instante. Como um gesto liga o
       descanso de 3s, `podeAndar()` era falso exatamente ali -- o intervalo
       morria e ninguém o chamava de volta. Resultado: o carrossel parava para
       sempre na primeira rolagem da página, que foi o que o Elber viu.

       Agora o intervalo roda sempre e cada tique pergunta se pode andar. Um
       `Date.now()` a cada 5 segundos não custa nada, e não há estado para
       ressuscitar. */
    function toca() {
      if (relogio) return;
      relogio = window.setInterval(function () {
        if (podeAndar()) avanca();
      }, espera);
    }

    /* ---------- o botao ---------- */

    if (ctrl) ctrl.hidden = false;

    if (botao && ctrl) {
      botao.addEventListener('click', function () {
        pedidoDoUsuario = !pedidoDoUsuario;
        botao.setAttribute('aria-pressed', pedidoDoUsuario ? 'true' : 'false');
        if (rotulo) rotulo.textContent = pedidoDoUsuario ? 'Continuar' : 'Pausar';
        ctrl.setAttribute('data-pausado', pedidoDoUsuario ? 'true' : 'false');
      });
    }

    /* ---------- as setas (09/09, pedido do Elber) ----------

       Clicar conta como GESTO, e nao como pausa. Ligar `pedidoDoUsuario` aqui
       faria a seta virar um botao de pausa disfarcado: quem clicasse uma vez
       para adiantar mataria o avanco automatico sem ter pedido isso, e sem
       saber, porque o rotulo do botao ao lado continuaria dizendo "Pausar".

       O que ela faz e adiar: os 3s de DESCANSO impedem que o relogio empurre
       o proximo cartao logo depois do clique, que seria dois avancos por um
       toque so. Quem quer parar de vez tem o botao do meio, a um centimetro
       dali. */
    function ligarSeta(botaoSeta, acao) {
      if (!botaoSeta) return;
      botaoSeta.addEventListener('click', function () {
        gestoAgora();
        acao();
      });
    }

    ligarSeta(seta_volta, volta);
    ligarSeta(seta_avanca, avanca);

    /* ---------- quando parar ---------- */

    /* Mouse e foco PARAM enquanto estao ali: quem esta lendo nao quer o
       cartao trocando embaixo do olho. */
    ['mouseenter', 'focusin'].forEach(function (ev) {
      trilho.addEventListener(ev, function () { tocando = true; toca(); }, { passive: true });
    });
    ['mouseleave', 'focusout'].forEach(function (ev) {
      trilho.addEventListener(ev, function () { tocando = false; gestoAgora(); toca(); }, { passive: true });
    });

    /* Gesto de dedo e rolagem nao PARAM, ADIAM. Segurar `tocando` no toque
       fazia o carrossel congelar em telas onde o dedo passa por cima sem
       intencao nenhuma; o descanso resolve melhor e sozinho. */
    ['touchstart', 'touchmove', 'touchend', 'pointerdown', 'scroll'].forEach(function (ev) {
      trilho.addEventListener(ev, gestoAgora, { passive: true });
    });
    window.addEventListener('touchmove', gestoAgora, { passive: true });

    document.addEventListener('visibilitychange', toca);
    window.addEventListener('resize', toca);

    /* Fora da tela nao anda: o depoimento que passou enquanto a pessoa lia
       outra secao e um depoimento que ela nunca viu. */
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entradas) {
        naTela = entradas[0].isIntersecting;
        toca();
      }, { threshold: 0.25 }).observe(trilho);
    } else {
      naTela = true;
    }

    toca();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
